<template>
    <div class="dial-container">
        <div class="dial-row">

            <!-- Title -->
            <div class="dial-title" v-html="title"></div>

            <!-- Cells -->
            <div class="dial-cells">
                <div v-for="index in cellCount" :key="index"
                    :class="[showHighContrast ? 'dial-cell-high-contrast' : '', 'dial-cell', value == null ? 'dial-cell-empty' : index <= filledCells ? fillClass : '']"></div>
            </div>

            <!-- Dial Status -->
            <div v-if="shownumber == 0" class="dial-status">{{ dialStatusName }}</div>
            <div v-if="shownumber == 1" class="dial-status">{{ valueString }}</div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        center: {
            type: Number,
            default: 50
        },
        title: {
            type: String,
            default: 'Dial'
        },
        shownumber: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            cellCount: 20
        };
    },
    computed: {
        showHighContrast() {
            return process.env.VUE_APP_HIGH_CONTRAST_DIALS === 'true';
        },
        valueString() {
            if (this.value == null) {
                return "";
            } else if (this.value == this.center) {
                return "0";
            } else if (this.value < this.center) {
                return (this.value - this.center);
            } else {
                return "+" + (this.value - this.center);
            }
        },
        fillRatio() {
            if (this.value == null || this.max <= this.min) {
                return 0;
            }
            const v = Math.max(this.min, Math.min(this.max, this.value));
            // Scale each side of the center separately, so the center always maps to exactly 0.5
            if (v < this.center) {
                return 0.5 * (v - this.min) / (this.center - this.min);
            } else if (v > this.center) {
                return 0.5 + 0.5 * (v - this.center) / (this.max - this.center);
            }
            return 0.5;
        },
        filledCells() {
            return Math.round(this.fillRatio * this.cellCount);
        },
        level() {
            if (this.fillRatio < 1 / 3) {
                return 0;
            } else if (this.fillRatio < 2 / 3) {
                return 1;
            }
            return 2;
        },
        fillClass() {
            return ['fill-low', 'fill-medium', 'fill-high'][this.level];
        },
        dialStatusName() {
            if (this.value == null) {
                return '';
            }
            if (this.title === 'Risicobereidheid') {
                return ['behoudend', 'evenwichtig', 'ondernemend'][this.level];
            }
            return ['licht gewogen', 'gemiddeld gewogen', 'zwaar gewogen'][this.level];
        }
    }
}
</script>

<style scoped>
.dial-container {
    width: 100%;
    padding: 0.4em 0;
    font-size: 13pt;
}

.dial-row {
    display: flex;
    align-items: center;
    gap: 1em;
}

.dial-title {
    flex: 0 0 25%;
    text-align: right;
    font-weight: bold;
    color: #222;
    line-height: 1.2em;
}

.dial-cells {
    display: flex;
    gap: 0.25em;
    flex: 0 0 auto;
}

.dial-cell {
    width: 0.8em;
    height: 2.2em;
    border-radius: 0.2em;
    background: #efebf5;
}

.dial-cell.dial-cell-empty,
.dial-cell-high-contrast.dial-cell-empty {
    background: #bdbdbd;
}

.dial-cell.fill-low {
    background: #c9b5e6;
}

.dial-cell.fill-medium {
    background: #9b77cf;
}

.dial-cell.fill-high,
.dial-cell-high-contrast.fill-high,
.dial-cell-high-contrast.fill-low,
.dial-cell-high-contrast.fill-medium {
    background: #4f2683;
}

.dial-status {
    flex: 1 1 auto;
    font-weight: bold;
    color: #3a1d5e;
    white-space: nowrap;
}
</style>
